import { JobQueue } from "@app/jobs/job-queues/jobQueue";
import { ServiceBase } from "@app/shared";
import { querystringify } from "../../shared/utility";
import { SortDirections } from "../../shared/waffles";
import { JobQueueMapListItem } from "./../jobQueueMapListItem";
import { JobQueueMapSummary } from "./../jobQueueMapSummary";
import { JobType } from "./../jobType";

export default class JobQueueService extends ServiceBase {
  public async getJobQueues(): Promise<JobQueue[]> {
    return await this.makeGet<JobQueue[]>(`jobqueues`);
  }

  public async getAvailableJobQueues(allowDirtyReads?: boolean): Promise<JobQueue[]> {
    const query = {
      allowDirtyReads: allowDirtyReads ?? false
    }

    return await this.makeGet<JobQueue[]>(`jobqueues/available?${querystringify(query)}`);
  }

  public async getJobQueueMapSummary(skip: number, take: number, jobTypes: string[], sortedColumn: string, sortDirection?: SortDirections,
    jobQueueFilter?: string, clientFilter?: string, projectFilter?: string, countySSAFilter?: string): Promise<JobQueueMapSummary> {
    const requestModel = {
      clientFilter,
      countySSAFilter,
      jobQueueFilter,
      offset: skip,
      pageSize: take,
      projectFilter,
      selectedJobTypes: jobTypes,
      sortDirection,
      sortedColumn,
    };

    return await this.makePost<JobQueueMapSummary>(`jobqueues/map/summary`, requestModel);
  }

  public async postJobQueueMap(jobQueueId: number, jobType?: JobType, clientId?: number, projectId?: number, countySSA?: string): Promise<JobQueueMapListItem> {
    const postModel = {
      clientId,
      countySSA,
      jobQueueId,
      jobType,
      projectId,
    };

    return await this.makePost<JobQueueMapListItem>(`jobqueues/map`, postModel);
  }

  public async deleteJobQueueMaps(jobQueueMapIds: string[]): Promise<void> {
    return await this.makeDelete<void>(`jobqueues/map`, jobQueueMapIds.map((s) => +s));
  }

  public async getJobQueue(jobType: JobType, clientId: number, projectId: number, countySSA: string): Promise<JobQueue> {
    const jobTypeValue = Object.entries(JobType).find((t) => t[1] === jobType)[0];
    return await this.makeGet<JobQueue>(`jobqueues/map?jobTypeId=${jobTypeValue}&clientId=${clientId}&projectId=${projectId}&countySSA=${countySSA}`);
  }

  public async updateJobQueue(jobQueue: JobQueue) : Promise<JobQueue> {
    return await this.makePost<JobQueue>(`jobqueues`, jobQueue);
  }

  public async deleteJobQueue(id: number) : Promise<void> {
    return await this.makeDelete<void>(`jobqueues/${id}`);
  }
}
